import { render, staticRenderFns } from "./SendWishlist.vue?vue&type=template&id=08683566&"
import script from "./SendWishlist.vue?vue&type=script&lang=js&"
export * from "./SendWishlist.vue?vue&type=script&lang=js&"
import style0 from "./SendWishlist.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports